import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientBillingApiAdapter, UpdateBillingRequest } from '../adapters/ClientBillingApiAdapter';

export const useUpdateBilling = (teamId: number) => {
    const queryClient = useQueryClient();

    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientBillingApiAdapter(httpClient);
    }, []);

    const mutation = useMutation({
        mutationFn: (data: UpdateBillingRequest) =>
            apiAdapter.updateBilling(teamId, data),
        onSuccess: () => {
            // Invalidar la cache del cliente para refrescar los datos
            queryClient.invalidateQueries({ queryKey: ['client', teamId] });
        },
    });

    return {
        updateBilling: mutation.mutate,
        updateBillingAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
        isSuccess: mutation.isSuccess,
        error: mutation.error,
        reset: mutation.reset,
    };
};

